export const spinnerActions = {
  showSpinner: (payload = {}) => ({ type: 'SPINNER_SHOWN', payload }),
  hideSpinner: () => ({ type: 'SPINNER_HIDDEN' }),
};
